
import { defineComponent, onMounted, ref } from 'vue';
import {
  getReviewRequests,
  PartnerReviewRequestResource,
} from '@/api/partnerReviewApi';
import PartnerRequestListItem from '@/components/PartnerRequestListItem.vue';
import { useStore } from 'vuex';
import { key } from '@/store';

export default defineComponent({
  name: 'ReviewRequestPage',
  components: { PartnerRequestListItem },
  setup() {
    const store = useStore(key);
    const reviewRequest = ref<PartnerReviewRequestResource[]>([]);

    const toggleSidebar = () => {
      store.commit('setSidebarState', !store.state.layout.isSidebarOpen);
    };

    onMounted(() => {
      getReviewRequests().then(res => {
        reviewRequest.value = res;
      });
    });

    return {
      reviewRequest,
      toggleSidebar,
    };
  },
});
